export let DATA_SOURCE_RECORD_RELATIONSHIP;
(function (DATA_SOURCE_RECORD_RELATIONSHIP) {
  DATA_SOURCE_RECORD_RELATIONSHIP["ONE_TO_ONE"] = "ONE_TO_ONE";
  DATA_SOURCE_RECORD_RELATIONSHIP["ONE_TO_MANY"] = "ONE_TO_MANY";
})(DATA_SOURCE_RECORD_RELATIONSHIP || (DATA_SOURCE_RECORD_RELATIONSHIP = {}));
export let CONNECTION_TYPE;
(function (CONNECTION_TYPE) {
  CONNECTION_TYPE["ONE_TO_MANY"] = "ONE_TO_MANY";
  CONNECTION_TYPE["ONE_TO_ONE"] = "ONE_TO_ONE";
  CONNECTION_TYPE["MANY_TO_ONE"] = "MANY_TO_ONE";
})(CONNECTION_TYPE || (CONNECTION_TYPE = {}));
export let DataSourceType; // used when we filter out all the properties and show a none found msg
(function (DataSourceType) {
  DataSourceType["CONTAINER"] = "CONTAINER";
  DataSourceType["ACTION_OUTPUT"] = "ACTION_OUTPUT";
  DataSourceType["FETCHED_OBJECT"] = "FETCHED_OBJECT";
  DataSourceType["ENROLLMENT_EVENT"] = "ENROLLMENT_EVENT";
  DataSourceType["ENROLLMENT_DATASET_COLUMN"] = "ENROLLMENT_DATASET_COLUMN";
  DataSourceType["DATA_FIELDS"] = "DATA_FIELDS";
  DataSourceType["CONNECTION"] = "CONNECTION";
  DataSourceType["EMPTY"] = "EMPTY";
})(DataSourceType || (DataSourceType = {}));
export const RecordFilterTypes = {
  ASSOCIATION_LABEL: 'ASSOCIATION_LABEL',
  ASSOCIATION_TIMESTAMP: 'ASSOCIATION_TIMESTAMP',
  MATCHING_PROPERTY: 'MATCHING_PROPERTY'
};
export let SortRecordBy;
(function (SortRecordBy) {
  SortRecordBy["HS_LASTMODIFIEDDATE"] = "HS_LASTMODIFIEDDATE";
  SortRecordBy["HS_CREATEDATE"] = "HS_CREATEDATE";
})(SortRecordBy || (SortRecordBy = {}));
export let AssociationTimestampOrder;
(function (AssociationTimestampOrder) {
  AssociationTimestampOrder["MOST_RECENTLY_ASSOCIATED"] = "MOST_RECENTLY_ASSOCIATED";
  AssociationTimestampOrder["FIRST_ASSOCIATED"] = "FIRST_ASSOCIATED";
})(AssociationTimestampOrder || (AssociationTimestampOrder = {})); // we may want to consider a map, list or an Immutable here